import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-botao-voltar',
  templateUrl: './botao-voltar.component.html',
  styleUrls: ['./botao-voltar.component.scss'],
})
export class BotaoVoltarComponent {
  @Input() link: string;
  @Input() name = 'Voltar';
  @Output() backClick = new EventEmitter<PointerEvent | TouchEvent>();

  constructor(private location: Location, private router: Router) {}

  handleNavigateToPreviousPage(event: PointerEvent): void {
    if (this.link) {
      this.router.navigate([this.link], { replaceUrl: true });
    } else {
      this.location.back();
    }
    this.backClick.emit(event);
  }
}

